import axios from 'axios'

export default {
  computed: {

  },
  methods: {
    getFinancialAccounts (active = null) {
      return new Promise(function (resolve, reject) {
        var url = 'company/financialAccounts'
        if (active !== null) url += '?active=' + active
        axios({ url: process.env.VUE_APP_REST_SERVICES_PATH + url, method: 'GET' })
          .then(response => {
            resolve(response.data)
          })
      })
    },
    getBranches (hasInventory = true, filterByPosUser = false) {
      return new Promise(function (resolve, reject) {
        var url = 'company/branchOffices?hasInventory=' + hasInventory + '&filterByPosUser=' + filterByPosUser
        axios({ url: process.env.VUE_APP_REST_SERVICES_PATH + url, method: 'GET' })
          .then(response => {
            resolve(response.data)
          })
      })
    },
    branchesPerType (branches) {
      const result = []
      var warehouses = []
      var stores = []
      for (var i = 0; i < branches.length; i++) {
        var value = branches[i].branchOfficeUuid
        var text = branches[i].name + ' (' + branches[i].code + ')'

        if (branches[i].officeType.catalogId === 'warehouse') {
          warehouses.push({ branchOfficeUuid: value, name: text })
        } else {
          stores.push({ branchOfficeUuid: value, name: text })
        }
      }

      if (warehouses.length > 0) {
        result.push({ label: 'Almacenes', options: warehouses })
      }
      if (stores.length > 0) {
        result.push({ label: 'Sucursales/Tiendas', options: stores })
      }
      return result
    },
    getCatalog (catalogType) {
      return new Promise(function (resolve, reject) {
        axios({ url: process.env.VUE_APP_REST_SERVICES_PATH + 'catalog/' + catalogType, method: 'GET' })
          .then(response => {
            resolve(response.data)
          })
      })
    },
    getTaxRegimes () {
      return new Promise(function (resolve, reject) {
        axios({ url: process.env.VUE_APP_REST_SERVICES_PATH + 'catalog/taxRegimes', method: 'GET' })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}
